var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import eventBus from '../../utils/fresh-table';
export default Vue.extend({
    name: 'simple-table',
    props: {
        border: {
            type: Boolean,
            default: false,
        },
        tableTitle: {
            type: String,
            default: function () {
                return '';
            },
        },
        requestConfig: {
            type: Object,
            required: true,
        },
        tableConfig: {
            type: Array,
            default: function () {
                return [];
            },
        },
        otherConfig: {
            type: Object,
            default: function () {
                return {};
            },
        },
        transResultFunc: {
            type: Function,
            default: null,
        },
        exportFunc: {
            type: Function,
            default: null,
        },
    },
    data: function () {
        return {
            resultList: [],
            pageNo: 1,
            pageSize: 20,
            totalItemCount: 0,
            isPagination: true,
        };
    },
    methods: {
        filter: function () {
            var _this = this;
            var _a = this.requestConfig, url = _a.url, method = _a.method, params = _a.params;
            var searchParam = __assign({ pageNo: this.pageNo, pageSize: this.pageSize }, params);
            this.$request({
                url: url,
                method: method,
                data: searchParam,
            }).then(function (res) {
                if (!res)
                    return;
                if (res.errorCode)
                    return;
                if (_this.transResultFunc) {
                    var pageInfo = {
                        pageSize: _this.pageSize,
                        pageNo: _this.pageNo,
                    };
                    res = _this.transResultFunc(res, pageInfo);
                }
                var pageNo = res.pageNo, pageSize = res.pageSize, totalItemCount = res.totalItemCount, data = res.data;
                _this.pageNo = pageNo;
                _this.pageSize = pageSize;
                _this.totalItemCount = totalItemCount;
                _this.resultList = data;
            });
        },
        sizeChange: function (val) {
            this.pageSize = val;
            this.filter();
        },
        currentChange: function (val) {
            this.pageNo = val;
            this.filter();
        },
        exportData: function () {
            if (this.exportFunc) {
                this.exportFunc();
            }
        },
        btnOpe: function (callback, row) {
            callback && typeof callback === 'function' && callback(row);
        },
    },
    mounted: function () {
        var _a = this.otherConfig, isPagination = _a.isPagination, lazyLoad = _a.lazyLoad;
        isPagination !== undefined && (this.isPagination = isPagination);
        eventBus.$on('freshSimpleTable', this.filter);
        !lazyLoad && this.filter();
    },
    beforeDestroy: function () {
        eventBus.$off('freshSimpleTable');
    },
});
